import React from 'react';
import { useNavigate } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowLeft } = FiIcons;

function Impressum() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white text-stone-800">
      <header className="fixed top-0 left-0 right-0 bg-white/90 backdrop-blur-md z-40 border-b border-stone-50">
        <div className="max-w-5xl mx-auto px-6 py-4 flex items-center gap-4">
          <button onClick={() => navigate('/')} className="p-2 hover:bg-stone-50 rounded-full transition-colors group">
            <SafeIcon icon={FiArrowLeft} className="w-5 h-5 text-stone-600 group-hover:text-stone-900" />
          </button>
          <h1 className="text-xl font-light tracking-tight text-stone-900">
            Mind Your Nature
          </h1>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 pt-32 pb-20">
        <h2 className="text-3xl font-light mb-12 text-stone-900">Impressum</h2>

        <div className="space-y-8 font-light text-stone-600 leading-relaxed">
          <div>
            <h5 className="font-medium text-stone-900 mb-3">Angaben gemäß § 5 TMG</h5>
            <p className="text-stone-600">
              Nadine Rau u. Mike Trepte GbR<br />
              Bettenhäuserstr. 1<br />
              34123 Kassel<br />
              Deutschland
            </p>
          </div>

          <div>
            <h5 className="font-medium text-stone-900 mb-2">Geschäftsführer</h5>
            <p>Nadine Rau, Mike Trepte</p>
          </div>

          <div>
            <h5 className="font-medium text-stone-900 mb-2">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h5>
            <p>Mike Trepte</p>
          </div>

          <div>
            <h5 className="font-medium text-stone-900 mb-2">Kontakt</h5>
            <p>
              Telefon: 0561 / 43027276<br />
              E-Mail: mike.trepte@underopensky.de
            </p>
          </div>

          <div>
            <h5 className="font-medium text-stone-900 mb-2">Standort</h5>
            <p>Kassel, Deutschland</p>
          </div>

          <div>
            <h5 className="font-medium text-stone-900 mb-2">Umsatzsteuer-ID</h5>
            <p>Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz: DE338605405</p>
          </div>

          <div>
            <h5 className="font-medium text-stone-900 mb-2">Redaktionell verantwortlich</h5>
            <p>
              Mike Trepte<br />
              Bettenhäuserstr. 1<br />
              34123 Kassel
            </p>
          </div>

          <div className="pt-6 border-t border-stone-200">
            <h5 className="font-medium text-stone-900 mb-3">Haftung für Inhalte</h5>
            <p className="mb-4">Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht unter der Verpflichtung, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.</p>
          </div>

          <div>
            <h5 className="font-medium text-stone-900 mb-3">Haftung für Links</h5>
            <p className="mb-4">Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.</p>
          </div>

          <div>
            <h5 className="font-medium text-stone-900 mb-3">Urheberrecht</h5>
            <p>Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.</p>
          </div>
        </div>
      </main>
    </div>
  );
}

export default Impressum;